export default class BtnProgress {
    static init(): void {
        const btns: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.btn-progress');

        if (btns.length > 0) {
            btns.forEach((btn: HTMLAnchorElement) => {
                let wasDownloaded = false;
                btn.addEventListener('click', () => {
                    const titleBefore = btn.querySelector('.btn-progress__title-before');
                    const titleAfter = btn.querySelector('.btn-progress__title-after');
                    const icon = btn.querySelector('.btn-progress__icon');
                    const newHref = btn.getAttribute('data-href');

                    if (titleBefore && titleAfter && icon && newHref && !wasDownloaded) {
                        btn.classList.add('animating');
                        setTimeout(() => {
                            btn.classList.remove('animating');
                            titleBefore.classList.add('none');
                            icon.classList.add('none');

                            icon.classList.remove('inline-flex');
                            btn.classList.add('btn-solid--green-caribbean');
                            titleAfter.classList.remove('none');
                            // window.location.href = btn.href;
                            btn.setAttribute('href', newHref);
                            btn.removeAttribute('download');
                            wasDownloaded = true;
                        }, 2500);
                    }
                });
            });
        }
    }
}
